import React from 'react';
import styles from './richtexteditor.module.css';

// Рендер-хелперы вынесены отдельно (без зависимости от TipTap),
// чтобы страницы, которым нужен только показ контента, не тянули редактор.
export { renderRich, MarkdownContent, ImageLightbox, useImageLightbox } from './richContent';

interface Props {
  value:        string;
  onChange:     (val: string) => void;
  placeholder?: string;
  rows?:        number;
  disabled?:    boolean;
  /** Урезанный тулбар (жирный/курсив/подчёркивание, ссылка, цвета, списки) — для заметок. */
  minimal?:     boolean;
  /** Максимальная высота области текста в px (внутри появляется скролл). */
  maxHeight?:   number;
  /** Загрузка изображения → публичный URL. Включает кнопку «Изображение»
   *  (вставка в текст). Второй аргумент — колбэк прогресса (см. TipTapEditor). */
  onImageUpload?: (file: File, onProgress?: (loaded: number, total: number) => void) => Promise<string>;
  /** compact — одна липкая строка тулбара и выбор типа блока (заголовки);
   *  только для полноэкранного редактора (новости). */
  variant?:     'default' | 'compact';
  /** Содержимое между тулбаром и текстом (compact: большой заголовок). */
  beforeContent?: React.ReactNode;
}

// TipTap-редактор грузится лениво — отдельным чанком, вне основного бандла.
const TipTapEditor = React.lazy(() => import('./TipTapEditor'));

// ── Редактор (WYSIWYG на TipTap, отдаёт HTML) ─────────────────────────
export default function RichTextEditor({
  value, onChange, placeholder, rows = 4, disabled, minimal, maxHeight, onImageUpload, variant, beforeContent,
}: Props) {
  const minH = `${Math.max(rows ?? 4, 2) * 24}px`;
  return (
    <React.Suspense
      fallback={<div className={styles.editorFallback} style={{ minHeight: minH }} />}
    >
      <TipTapEditor
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        maxHeight={maxHeight}
        features={minimal ? { minimal: true } : { spoiler: true, image: !!onImageUpload, headings: variant === 'compact' }}
        onImageUpload={onImageUpload}
        variant={variant}
        beforeContent={beforeContent}
      />
    </React.Suspense>
  );
}
